export default __webpack_public_path__ + "static/media/meat-enabled.baa87866.webp";